import { Nullable, Undefinedable } from "@/api/ApiClient";

export type InvoicePaymentFormData = Undefinedable<Nullable<{
    id: string | undefined,
    descripcion: string,
    monto: number,
    vuelto: number,
    formaPago: string,
    digitosTarjeta: string,
    numAprobacion: string,
    estado: string,
    exchangeRate: number,
    created: string,
    user: string,
    recibeId: string,
    recibe: any,
    currencyId: string,
    currency: any,
    bankAccountId: string,
    bankAccount: any,
    creditOperatorId: string,
    creditOperator: any,
    invoiceId: string,
    invoice: any,
}>>;

export const InvoicePaymentRelatedAttributes: Array<keyof InvoicePaymentFormData> = ["recibe", "currency", "bankAccount", "recibe", "creditOperator", "invoice"];